import {ebus} from '../vendor/ebus';
// (function () {
//
//     var lastSizeUpdate = 0;
//     var finalSizeUpdate = false;
//
//     function post_size(force) {
//         try {
//             var currentTime = new Date().getTime();
//             if (force || (currentTime - lastSizeUpdate > 1000)) {
//                 finalSizeUpdate = false;
//                 lastSizeUpdate = currentTime;
//                 var iframeHeight = document.body.scrollHeight;
//                 var msg = JSON.stringify({event: 'iframeHeight', height: document.body.scrollHeight});
//                 window.top.postMessage(msg, '*');
//             } else {
//                 finalSizeUpdate = true;
//             }
//         } catch (e) {
//             //console.log('???? suck exception');
//         }
//     }
//
//     var hostAllowed = ["mydomain.com", 'localhost:8888'];
//     var iframe = (parent !== window);
//     var url = null;
//     if (iframe) {
//         var domainOk = false;
//         url = document.referrer;
//         ref = url.match(/:\/\/(.[^/]+)/)[1];
//         for (i = 0; i <= hostAllowed.length; i++) {
//             //FIXME
//             // if (ref == hostAllowed[i]) {
//                 domainOk = true;
//                 // break;
//             // }
//         }
//
//         console.log('domainOk = ' + domainOk);
//         if (!domainOk) {
//             window.location.replace('https://' + window.host + '/404');
//         }
//     }
//
//     var mutationObserver = new MutationObserver(function (mutations) {
//         mutations.forEach(function (mutation) {
//             post_size();
//         });
//     });
//
//     document.addEventListener('DOMContentLoaded', function (event) {
//         //console.log('document.referrer = '+document.referrer);//https://localhost:8888/index.html
//         post_size(true);
//         setInterval(function () {
//             if (finalSizeUpdate) {
//                 post_size(true);
//             }
//         }, 1000);
//         mutationObserver.observe(document.documentElement, {
//             attributes: true,
//             characterData: true,
//             childList: true,
//             subtree: true,
//             attributeOldValue: true,
//             characterDataOldValue: true
//         });
//     });
// })();

let updateInterval = null;
let mutationObserver = null;
let lastSizeUpdate = 0;
let finalSizeUpdate = false;

function calcHeight(nodesList) {
    try {
        // if (!nodesList) {
        //     nodesList = document.documentElement.childNodes;
        // }
        let pageHeight = 0;
        // for (let i = nodesList.length - 1; i >= 0; i--) {
        //         //     if (nodesList[i].scrollHeight && nodesList[i].clientHeight) {
        //         //         let elHeight = Math.max(nodesList[i].scrollHeight, nodesList[i].clientHeight);
        //         //         pageHeight = Math.max(elHeight, pageHeight);
        //         //     }
        //         //     if (nodesList[i].childNodes.length) calcHeight(nodesList[i].childNodes);
        //         // }
        pageHeight = document.getElementById('scrollTop').clientHeight;
        return pageHeight;
    } catch (e) {
        console.log('Error in height: ' + e.message);
    }
    return null;
}

export function post(_msg) {
    try {
        let msg = JSON.stringify(_msg);
        console.log('postmessage: ' + msg);
        window.top.postMessage(msg, '*');
    } catch (e) {
        //console.log('???? suck exception');
    }
}

export function post_startRender() {
    post({event: 'startRenderOrderWidget'});
}

export function post_size(force) {
    try {
        let currentTime = new Date().getTime();
        if (force || (currentTime - lastSizeUpdate > 1000)) {
            finalSizeUpdate = false;
            lastSizeUpdate = currentTime;
            let iframeHeight = calcHeight();//document.body.offsetHeight;//document.body.scrollHeight;
            // console.log('iframeHeight: ' + iframeHeight);
            if (iframeHeight) {
                let msg = JSON.stringify({event: 'iframeHeight', height: iframeHeight});
                // console.log('post size: ' + msg);
                window.top.postMessage(msg, '*');
            }
        } else {
            finalSizeUpdate = true;
        }
    } catch (e) {
        //console.log('???? suck exception');
    }
}

export function destroy() {
    try {
        mutationObserver.disconnect();
    } catch (e) {

    }
    try {
        clearInterval(updateInterval);
    } catch (e) {

    }
}

export function init() {
    let hostAllowed = ["mydomain.com", 'localhost:8888'];
    let iframe = (parent !== window);
    let url = null;
    if (iframe) {
        let domainOk = false;
        url = document.referrer;
        let ref = url.match(/:\/\/(.[^/]+)/)[1];
        // for (i = 0; i <= hostAllowed.length; i++) {
        //FIXME
        // if (ref == hostAllowed[i]) {
        domainOk = true;
        // break;
        // }
        // }

        console.log('domainOk = ' + domainOk);
        if (!domainOk) {
            window.location.replace('https://' + window.location.host + '/404');
        }
    }

    mutationObserver = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            // console.log('iframe change observed...');
            post_size();
        });
    });

    // let initIframeObserver = function (event) {
    //     console.log('iframe change observed...');
    //     //console.log('document.referrer = '+document.referrer);//https://localhost:8888/index.html
    //     post_size(true);
    updateInterval = setInterval(function () {
        if (finalSizeUpdate) {
            post_size(true);
        }
    }, 400);
    mutationObserver.observe(document.documentElement, {
        attributes: true,
        characterData: true,
        childList: true,
        subtree: true,
        attributeOldValue: true,
        characterDataOldValue: true
    });
    // };
    //
    // if (document.readyState === "complete") {
    //     initIframeObserver();
    // }else{
    //     document.addEventListener('DOMContentLoaded', initIframeObserver);
    // }

    window.addEventListener("message", (e) => {
        try {
            console.log('got top message');
            if (e.data) {
                try {
                    let data = JSON.parse(e.data);
                    if (data.event === 'mainScroll') {
                        console.log('mainScroll received yOffset=' + data.yOffset);
                        ebus.$emit('mainScroll', JSON.parse(e.data))
                    }
                } catch (e) {
                }
            }
        } catch (e) {
            // alert('Uups parsing rawData error: ' + e);
            console.log('Uups parsing rawData error: ' + e);
        }
    }, false);

};

export function isInIframe() {
    try {
        return window.self !== window.top;
    } catch (e) {
        return true;
    }
}


